import { Role } from './AppContext';

export const GMG_ADMIN_ROLES = ['GMGAdmin', 'GMGSuperUser'] as const;
export const MEMBER_ROLES = ['Member'] as const;
export const GMG_PARTNER_ROLES = ['GMGPartner'] as const;
export const ORGANIZATION_ADMIN_ROLES = ['OrganizationAdmin'] as const;
export const ORGANIZATION_GROUP_ADMIN_ROLES = ['OrganizationGroupAdmin'] as const;
export const ORGANIZATION_LEVEL_ADMIN_ROLES = [
    ...ORGANIZATION_ADMIN_ROLES,
    ...ORGANIZATION_GROUP_ADMIN_ROLES,
    ...GMG_PARTNER_ROLES,
] as const;

type RoleGroup = ReadonlyArray<Role>;

const isRoleInGroup = (role: Role | undefined, group: RoleGroup): boolean => {
    if (!role) return false;
    return group.includes(role);
};

export const isGmgAdminRole = (role: Role | undefined): boolean => {
    return isRoleInGroup(role, GMG_ADMIN_ROLES);
};

export const isMemberRole = (role: Role | undefined): boolean => {
    return isRoleInGroup(role, MEMBER_ROLES);
};

export const isOrganizationAdminRole = (role: Role | undefined): boolean => {
    return isRoleInGroup(role, ORGANIZATION_ADMIN_ROLES);
};

export const isOrganizationGroupAdminRole = (role: Role | undefined): boolean => {
    return isRoleInGroup(role, ORGANIZATION_GROUP_ADMIN_ROLES);
};

export const isGmgPartnerRole = (role: Role | undefined): boolean => {
    return isRoleInGroup(role, GMG_PARTNER_ROLES);
};

export const isOrganizationLevelAdminRole = (role: Role | undefined): boolean => {
    return isRoleInGroup(role, ORGANIZATION_LEVEL_ADMIN_ROLES);
};
